import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Menu } from 'lucide-react';

export const DashboardHeader = ({ dashboardData, getSubscriptionStatusColor, logout, practice, setSidebarOpen, sidebarOpen }) => (
  <>
    <div className="bg-white shadow-sm border-b">
      <div className="w-full px-3 py-3">
        <div className="flex items-center justify-between">
          {/* Left Section: Hamburger + Logo + Practice Info */}
          <div className="flex items-center space-x-2 flex-1 min-w-0">
            {/* Menu Toggle Button */}
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="hover:bg-gray-100"
            >
              <Menu className="h-5 w-5" />
            </Button>

            {/* Practice Logo */}
            {(practice?.branding?.logo || practice?.logo) ? (
              <img 
                src={practice.branding?.logo || practice.logo}
                alt={`${practice.name || 'Practice'} Logo`}
                className="h-6 w-auto object-contain"
                onError={(e) => {
                  console.error('Custom logo failed to load, falling back to default');
                  e.target.src = "/practcom-logo.png";
                }}
              />
            ) : (
              <img 
                src="/practcom-logo.png"
                alt="PractCom Logo"
                className="h-6 w-auto"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            )}
            <div className="min-w-0">
              <h1 className="text-lg font-bold text-gray-900 truncate">
                {dashboardData?.practice?.name || 'Practice Dashboard'}
              </h1>
              <p className="text-sm text-gray-600 truncate">
                Welcome Back
              </p>
            </div>
          </div>

          {/* Center Section: PractCom Logo - Fills 2/3 of available space */}
          <div className="hidden xl:flex flex-1 justify-center items-center px-4">
            <div className="flex flex-col items-center">
              <h1 
                className="text-2xl md:text-3xl lg:text-4xl font-bold tracking-wide"
                style={{
                  background: 'linear-gradient(135deg, #0d9488 0%, #14b8a6 50%, #2dd4bf 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  letterSpacing: '0.08em'
                }}
              >
                PractCom
              </h1>
              <p className="text-gray-500 text-sm tracking-[0.08em] mt-0.5" style={{ fontWeight: 500 }}>
                The Total Practice Communication System for Dental Offices
              </p>
            </div>
          </div>

          {/* Right Section: Subscription Badge + Sign Out */}
          <div className="flex items-center space-x-2 flex-1 justify-end">
            <Badge className={getSubscriptionStatusColor(dashboardData?.stats?.subscriptionStatus)}>
              {dashboardData?.stats?.subscriptionStatus === 'active' && '✅ ACTIVE'}
              {dashboardData?.stats?.subscriptionStatus === 'trial' && '🎯 TRIAL'}
              {dashboardData?.stats?.subscriptionStatus === 'cancelled' && '⛔ CANCELLED'}
              {dashboardData?.stats?.subscriptionStatus === 'beta' && '🚀 BETA'}
              {!['active', 'trial', 'cancelled', 'beta'].includes(dashboardData?.stats?.subscriptionStatus) && 
                (dashboardData?.stats?.subscriptionStatus?.toUpperCase() || 'INACTIVE')}
            </Badge>
            <Button variant="outline" onClick={logout}>
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </div>
  </>
);
